<script lang="ts">
  import Router from "svelte-spa-router";
  import NavBar from "../libs/components/NavBar.svelte";
  import { bridge } from "./lib/bridge";
  import { supportsShare } from "./lib/version";
  import { _ as t } from "svelte-i18n";
  import Home from "./pages/Home.svelte";
  import lineShareIcon from "./assets/images/line_share.png";
  import Logo from "./assets/images/logo.png";

  const routes = {
    "/": Home,
  };

  const showShare = supportsShare();

  function handleClose() {
    bridge.callNative("Route_HomePage");
  }

  const shareUrl =
    __MODE__ === "prod"
      ? "https://common-h5.chiefgroup.com.hk/47th-activity-mainHall/"
      : "https://common-h5.test.stx365.com/47th-activity-mainHall/";

  function handleShare() {
    bridge.callNative("share", {
      title: $t("page_title"),
      shareContentText: shareUrl,
    });
  }
</script>

<NavBar
  onClose={handleClose}
  bgOpacity={0}
  lightBgColor="#0E2C8C"
  lightTextColor="#ffffff"
  darkBgColor="#0E2C8C"
  darkTextColor="#ffffff"
  disableOffsetUp={true}
>
  {#snippet right()}
    {#if showShare}
      <button
        class="flex items-center justify-center w-[32px] h-[32px]"
        onclick={handleShare}
      >
        <img src={lineShareIcon} alt="share" class="w-[20px] h-[20px]" />
      </button>
    {/if}
  {/snippet}
  {#snippet titleCustom()}
    <img src={Logo} alt="logo" style="width: 123px;" />
  {/snippet}

  <Router {routes} />
</NavBar>